import { Lock, LogOut } from "lucide-react";
import { PhoenixWordmark } from "@/components/PhoenixLogo";

export function SubscriptionLockScreen({ onLogout, audience = "staff" }) {
    return (
        <div data-testid="subscription-lock-screen" className="min-h-screen bg-phoenix-mesh flex flex-col">
            <header className="max-w-6xl mx-auto w-full px-6 py-6">
                <PhoenixWordmark />
            </header>
            <div className="flex-1 flex items-center justify-center px-6">
                <div className="max-w-md w-full bg-white rounded-3xl shadow-phoenix-card border border-border/60 p-8 text-center">
                    <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-destructive/10 flex items-center justify-center">
                        <Lock className="w-7 h-7 text-destructive" />
                    </div>
                    <h1 className="font-display font-bold text-2xl text-phoenix-navy mb-2">
                        Access suspended
                    </h1>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                        {audience === "inmate"
                            ? "This service is temporarily unavailable. Please check with facility staff."
                            : "Your facility's Blue Phoenix subscription is unpaid and access has been suspended. Please contact Blue Phoenix billing to restore access — once the invoice is marked paid, access returns immediately."}
                    </p>
                    {onLogout && (
                        <button
                            onClick={onLogout}
                            data-testid="lock-screen-logout"
                            className="mt-6 inline-flex items-center gap-2 px-4 py-2.5 bg-phoenix-navy text-white text-sm font-semibold rounded-xl hover:bg-phoenix-navy-2 transition-colors"
                        >
                            <LogOut className="w-4 h-4" /> Sign out
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
